import baseMakeStyles, { CustomMakeStyles } from '@shared/theme/makeStyles';
import { SetCssVarHook, useBaseSetCssVar } from '@shared/theme/predefinedVars';
import baseStyled, { CustomStyled } from '@shared/theme/styled';
import cssVars from './cssVars';
import { ProjectPortalTheme } from './types';

export const makeStyles = baseMakeStyles as CustomMakeStyles<ProjectPortalTheme>;

export const styled = baseStyled as CustomStyled<ProjectPortalTheme>;

export { default as buildTheme } from './buildTheme';

export const useSetCssVar = useBaseSetCssVar as SetCssVarHook<keyof typeof cssVars>;
